import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
export var LOCATION_TYPES = {
    airport: "airport",
    all: "all",
    city: "city",
    citywithoutrail: "citywithoutrail",
    multiairport_single: "multiairport_single",
    multiairports: "multiairports",
    multirail_single: "multirail_single",
    normal: "normal",
    multirail: "multirail",
    rail_only: "rail_only",
    rail: "rail"
};
export var getDisplayName = function(suggestion) {
    return "".concat(suggestion.cityName).concat(suggestion.typeDisplay ? " ".concat(suggestion.typeDisplay) : "");
};
export function getLocation(suggestion) {
    var name = getDisplayName(suggestion);
    var baseLocation = {
        name: name,
        cityCode: suggestion.bmCode,
        cityName: suggestion.cityName
    };
    switch(suggestion.type){
        case LOCATION_TYPES.multiairport_single:
        case LOCATION_TYPES.airport:
        case LOCATION_TYPES.multiairports:
            return _object_spread_props(_object_spread({}, baseLocation), {
                type: "airport",
                iataCode: String(suggestion.airportCode)
            });
        case LOCATION_TYPES.city:
        case LOCATION_TYPES.citywithoutrail:
            return _object_spread_props(_object_spread({}, baseLocation), {
                type: "city"
            });
        case LOCATION_TYPES.multirail:
        case LOCATION_TYPES.rail_only:
        case LOCATION_TYPES.multirail_single:
            return _object_spread_props(_object_spread({}, baseLocation), {
                type: "rail",
                railCode: String(suggestion.railCode)
            });
        default:
            return _object_spread_props(_object_spread({}, baseLocation), {
                type: "all"
            });
    }
}
